export const MAX_PRACTICE_SLOTS = 10;
export const PRACTICE_SLOT_NUMBERS = Object.freeze(Array.from({ length: MAX_PRACTICE_SLOTS }, (_, index) => index + 1));
